<template>
  <div class="page-wrapper">
    <menu-dispatcher></menu-dispatcher>
    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                Справочники
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directorys-tabs">
                  <ul class="tabs">
                    <li :class="{active: pageNumber == 0}" data-page="0" @click="pageNumber = 0">Вывоз мусора</li>
                    <li :class="{active: pageNumber == 1}" data-page="1" @click="pageNumber = 1">Районы вывоза мусора
                    </li>
                  </ul>
                  <div>
                    <garbage-removal-categories v-show="pageNumber == 0"></garbage-removal-categories>
                    <garbage-disposal-districts v-show="pageNumber == 1"></garbage-disposal-districts>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import GarbageRemovalCategories from '@/views/GarbageRemovalCategories.vue'
    import GarbageDisposalDistricts from '@/views/GarbageDisposalDistricts.vue'

    export default {
  name: 'GarbageRemoval',
  components: {
    MenuDispatcher,
    HeaderDispatcher,
    GarbageDisposalDistricts,
    GarbageRemovalCategories
  },

  data () {
    return {
      pageNumber: 0
    }
  },

  mounted () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('cabinet-page')
  }
}
</script>
